<template>  
    <div>
        <b-card no-body>
            <b-card-header>
                <div class="float-left">
                    <span class="h5">Atualizar Boletim de Medição <span class="badge badge-warning">{{ statusBoletimMedicao }}</span> </span>
                </div>
                <div class="float-right">
                    <button class="btn btn-link" @click.stop="voltar()">
                        <i class="fa fa-arrow-left mr-2"></i>Voltar para os detalhes de boletins
                    </button>
                </div>
            </b-card-header>
            <b-card-body>
                <boletim-medicao-form 
                    :contrato="contrato"
                    :valor-total-boletins="valorTotalBoletins"
                    @recarregarDadosBoletim="voltar"
                    @atualizarStatusBoletimMedicao="atualizarStatusBoletimMedicao"
                />
            </b-card-body>
        </b-card>
    </div>
</template>

<script>

import BoletimMedicaoForm from './componentes/BoletimMedicaoForm.vue';

export default {

    components: {
        BoletimMedicaoForm
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },
        valorTotalBoletins: {
            type: Number,
            default: 0
        },
    },

    data() {
        return {
            statusBoletimMedicao: null,
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'FornecedorContratos_BoletinsMedicoes_Detalhar' })
        },

        atualizarStatusBoletimMedicao(status) {
            this.statusBoletimMedicao = status;
        }
    },
}
</script>